import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Star } from "lucide-react";
import { api, formatError } from "../lib/api";
import { toast } from "sonner";

export default function ReviewRequest() {
  const { token } = useParams();
  const [rr, setRr] = useState(null);
  const [err, setErr] = useState(null);
  const [form, setForm] = useState({ name: "", location: "", rating: 5, content: "" });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    api.get(`/review/${token}`).then((r) => {
      setRr(r.data);
      setForm((f) => ({ ...f, name: r.data.name || "" }));
      if (r.data.submitted) setSubmitted(true);
    }).catch((e) => setErr(formatError(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/review/${token}`, form);
      setSubmitted(true);
      toast.success("Thank you for your review!");
    } catch (e2) { toast.error(formatError(e2)); }
  };

  if (err) return <div className="py-24 px-6 text-center text-white/60" data-testid="review-error">{err}</div>;
  if (!rr) return <div className="py-24 px-6 text-white/50">Loading…</div>;
  if (submitted) return (
    <div className="py-24 px-6 max-w-2xl mx-auto text-center" data-testid="review-thanks">
      <h1 className="font-serif text-4xl">Thank you</h1>
      <p className="mt-4 text-white/70">Your review has been received and will be published after a quick review.</p>
    </div>
  );

  return (
    <div className="py-20 px-6 max-w-2xl mx-auto" data-testid="review-page">
      <div className="overline">Share Your Experience</div>
      <h1 className="font-serif text-4xl mt-2">How was your {rr.service_name}?</h1>
      <p className="text-white/70 mt-4">Your honest review helps others find Lyon's Den Protection.</p>
      <form onSubmit={submit} className="mt-10 space-y-6">
        <input required value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})} placeholder="Name" className="w-full bg-transparent border-b border-white/20 py-3 outline-none" data-testid="review-name"/>
        <input value={form.location} onChange={(e)=>setForm({...form, location:e.target.value})} placeholder="Location (optional)" className="w-full bg-transparent border-b border-white/20 py-3 outline-none" data-testid="review-location"/>
        <div className="flex gap-2">
          {[1,2,3,4,5].map((n) => (
            <button type="button" key={n} onClick={()=>setForm({...form, rating:n})} className={form.rating>=n?"text-[#D4AF37]":"text-white/30"} data-testid={`review-rating-${n}`}>
              <Star size={26} fill={form.rating>=n?"#D4AF37":"none"} />
            </button>
          ))}
        </div>
        <textarea required rows={6} value={form.content} onChange={(e)=>setForm({...form, content:e.target.value})} placeholder="Tell others about your experience…" className="w-full bg-transparent border-b border-white/20 py-3 outline-none" data-testid="review-content"/>
        <button type="submit" className="bg-[#8B0000] hover:bg-[#A50000] text-white px-10 py-4 text-xs uppercase tracking-[0.2em]" data-testid="review-submit">Submit Review</button>
      </form>
    </div>
  );
}
